export const idExtractor = (str, splitChar) => {
    const strArray = str.split(splitChar)
    return strArray
}